import { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { logoutUser } from '../redux/authSlice';
import { toggleMenuOpen } from '../redux/menuSlice';
import { ROUTE_BACK_OFFICE_HOME, ROUTE_BACK_OFFICE_SETTINGS } from '../../constants';
import './Header.css';

const Header = () => {
  const targetElementRef = useRef(null);
  const contextMenuRef = useRef(null);
  const [isContextMenuOpen, setContextMenuOpen] = useState(false);
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMenuOpen = useSelector((state) => state.backOfficeMenuBar.isMenuOpen);

  const handleMenuIconClick = (event) => {
    event.stopPropagation();
    dispatch(toggleMenuOpen());
    handleClick(event);
  };

  const handleClick = (event) => {
    if (contextMenuRef.current && !contextMenuRef.current.contains(event.target) &&
        targetElementRef.current && !targetElementRef.current.contains(event.target)) {
      setContextMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  const handleLogout = () => {
    dispatch(logoutUser(navigate));
  };

  const toggleProfileMenu = () => {
    setContextMenuOpen(!isContextMenuOpen);
  };

  const getUserInitials = () => {
    const user = auth.user;
    if (user) {
      const firstName = user.firstName || '';
      const lastName = user.lastName || '';
      return firstName.charAt(0) + lastName.charAt(0);
    }
    return '';
  };

  window.onclick = function(event) {
    if (isMenuOpen) {
      event.stopPropagation();
      dispatch(toggleMenuOpen());
      handleClick(event);
    }
  };

  return (
    <div className="header">
      <div className='left-section'>
        <Link to={ROUTE_BACK_OFFICE_HOME}>
          <img src="/images/logo492.jpg" className="logo" alt='TypeHero Logo' />
        </Link>
      </div>
      <div className='right-section'>
        {auth.user && (
        <>
          <div ref={targetElementRef} className="profile icon" onClick={(event) => toggleProfileMenu(event)}>
            <span className="initials" data-initials={getUserInitials()}>{getUserInitials()}</span>
          </div>
          <div ref={contextMenuRef} id="contextMenu" className={`context-menu${isContextMenuOpen ? ' show' : ''}`}>
            <span onClick={() => { setContextMenuOpen(false); navigate(ROUTE_BACK_OFFICE_SETTINGS); }}>
              <i className="bx bx-cog"></i> Settings
            </span>
            <span onClick={(event) => handleLogout(event)}>
              <i className="bx bx-log-out"></i> Logout
            </span>
          </div>
          <div className='menu-icon'>
            <i className={`bx bx-menu menu-icon ${isMenuOpen ? 'bx-menu-alt-left' : 'bx-menu'}`} onClick={handleMenuIconClick}></i>
          </div>
        </>
        )}
      </div>
    </div>
  );
};

export default Header;